/* eslint-disable no-nested-ternary */
/* eslint-disable default-param-last */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
import {
  Box,
  TableCell,
  TableRow,
  Tooltip,
  Button as MuiButton,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Formik } from "formik";
import React, { useContext, useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import * as Sentry from "@sentry/react";
import CustomTable from "../../../../components/common/new/Table/Table";
import { DIRECT_APPOINTMENT_COL } from "../../../../contants/table/appointment";
import Styles from "./DirectAppointment.styles";
import Button from "../../../../components/common/Button";
import Typography from "../../../../components/common/new/Typography/Typography";
import { isEmptyObj } from "../../../../utils/helper";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import { AlertStatus } from "../../../../contants";
import Appointment from "../../../../services/api/appointment";
import Loader from "../../../../components/common/Loader/Loader";
import { getDirectAppointmentType } from "../../../../utils";
import Alert from "../../../../components/common/new/Alert/Alert";
import SearchResultNationalSpecial from "../components/SearchResultNationalSpecial";
import Dropdown from "../../../../components/common/new/Dropdown/Dropdown";

const APPOINTMENT_TYPE_SEARCH = {
  TYPE: "type",
};

const GROUP_OPTIONS = [
  {
    value: "FD",
    key: "Future Division",
    divisionIds: "52,53",
    subdivisionIds: "54,55,56,7,9,11",
  },
  {
    value: "SD",
    key: "Student Division",
    divisionIds: "3,37",
    subdivisionIds: "57,58",
  },
];

function NationalSpecialGroup() {
  const [showTable, setShowTable] = useState(false);
  const toast = useContext(ToastAlertContext);
  const [modalOpen, setModalOpen] = useState(false);
  const [appointedMembers, setAppointedMembers] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [searchData, setSearchData] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState({
    groupId: null,
    members: [],
    positionId: null,
    membersDetails: [],
    positionType: "",
  });
  const [payload, setPayload] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [openDeleteAlert, setOpenDeleteAlert] = useState(false);
  const [selectedAreaName, setSelectedAreaName] = useState("");
  const isMobile = useMediaQuery("(max-width: 768px)");

  const acceptAppointmentHandler = () => {
    setOpenAlert(true);
  };

  const deleteAppointmentHandler = () => {
    setOpenDeleteAlert(true);
  };

  const toggleAlert = () => {
    setOpenAlert(false);
  };

  const toggleDeleteAlert = () => {
    setOpenDeleteAlert(false);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedRow(null);
    setAppointedMembers([]);
    setSelectedGroup({
      groupId: null,
      members: [],
      positionId: null,
      membersDetails: [],
      positionType: "",
    });
  };

  const valuesArray = Object.values(selectedAreaName);

  const getGroupData = (data) => {
    const searchData = data;

    const groupedData = [];
    searchData.forEach((item) => {
      if (item?.subDivisionName.toLowerCase().includes("cubs")) {
        const existingCubsGroup = groupedData.find(
          (group) =>
            group?.subDivisionName === "Cubs" &&
            group?.positionName === item?.positionName
        );

        if (existingCubsGroup) {
          if (item?.memberDetails !== null) {
            existingCubsGroup.members.push(item?.memberDetails);
            let nullEncountered = false;
            existingCubsGroup.members = existingCubsGroup.members.filter(
              (member) => {
                if (member === null && !nullEncountered) {
                  nullEncountered = true;
                  return true;
                }
                return member !== null;
              }
            );
          }
        } else {
          const members =
            item?.memberDetails !== null ? [item?.memberDetails] : [];
          groupedData.push({
            id: uuidv4(),
            divisionName: item?.divisionName,
            positionName: item?.positionName,
            subDivisionName: "Cubs",
            positionType: item?.positionType,
            positionId: item?.positionId,
            divisionId: item?.divisionId,
            subDivisionId: item?.subdivisionId,
            members,
          });
        }
      } else {
        const existingRow = groupedData.find(
          (row) =>
            row?.divisionName === item?.divisionName &&
            row?.positionName === item?.positionName &&
            row?.subDivisionName === item?.subDivisionName
        );

        if (existingRow) {
          existingRow.members.push(item?.memberDetails);
        } else {
          groupedData.push({
            id: uuidv4(),
            divisionName: item?.divisionName,
            positionName: item?.positionName,
            subDivisionName: item?.subDivisionName,
            positionType: item?.positionType,
            positionId: item?.positionId,
            divisionId: item?.divisionId,
            subDivisionId: item?.subdivisionId,
            members: [item?.memberDetails],
          });
        }
      }
    });
    return groupedData;
  };

  const handleAppointNew = (id) => {
    const selectedRowData = searchData.find((d) => d.id === id);
    const {
      positionId,
      divisionId,
      divisionName,
      positionName,
      subDivisionId,
    } = selectedRowData;
    const overridePosition = !!selectedGroup?.members.length;

    const selectedMemberIds = selectedGroup?.members || [];

    const selectedMembersDetails = selectedGroup?.membersDetails || [];

    const updatedAppointedMembers = {
      positionId,
      selectedMembers: selectedMemberIds,
      overridePosition,
      divisionId,
      divisionName,
      positionName,
      subDivisionId,
      selectedMembersDetails,
      valuesArray,
    };

    setAppointedMembers([updatedAppointedMembers]);
    setSelectedRow(selectedRowData);
    setModalOpen(true);
  };

  const toggleMemberSelection = (
    memberId,
    positionId,
    groupId,
    isChecked,
    memberDetails,
    positionType
  ) => {
    const addMember = (members, id) => members.concat(id);
    const removeMember = (members, id) => members.filter((mId) => mId !== id);

    setSelectedGroup((prev) => {
      // add member to already existing group
      if (prev.groupId === groupId) {
        const updatedMembers = isChecked
          ? addMember(prev?.members, memberId)
          : removeMember(prev?.members, memberId);
        const updatedMemberDetails = isChecked
          ? [...prev.membersDetails, memberDetails]
          : prev.membersDetails.filter(
              (member) => member?.memberId !== memberId
            );

        return {
          ...prev,
          members: updatedMembers,
          membersDetails: updatedMemberDetails,
        };
      } // add member to new group
      return {
        groupId,
        positionId,
        members: isChecked ? addMember([], memberId) : [],
        membersDetails: isChecked ? [memberDetails] : [],
        positionType,
      };
    });
  };

  const fetchData = async (params) => {
    try {
      setIsLoading(true);
      const result =
        await Appointment.specialGroupDirectAppointmentApplications({
          ...params,
        });
      setSearchData(getGroupData(result?.data?.appointments));

      setSelectedAreaName(selectedAreaName);
      setPayload(params);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      Sentry.captureException(err);
    }
  };

  const handleRemove = async () => {
    try {
      setIsLoading(true);
      const positionid = selectedGroup.positionId;
      const memberId = selectedGroup.members ? selectedGroup.members : [];
      const positiontype = selectedGroup.positionType;

      const body = {
        memberIds: memberId,
        positionId: positionid,
        positionType: positiontype,
      };

      await Appointment.directAppointmentRemoveApplications(payload, body);
      toast.show("Removed Successfully", AlertStatus.SUCCESS);
      toggleAlert();
      setTimeout(() => {
        fetchData(payload);
        toggleAlert();
      }, 2000);
      setIsLoading(false);
      setSelectedGroup({
        groupId: null,
        members: [],
        positionId: null,
        membersDetails: [],
      });
    } catch (err) {
      setIsLoading(false);
      Sentry.captureException(err);
    }
  };

  const handleDelete = async () => {
    try {
      setIsLoading(true);
      const positionid = selectedGroup.positionId;
      const memberId = selectedGroup.members ? selectedGroup.members : [];
      const positiontype = selectedGroup.positionType;

      const body = {
        memberIds: memberId,
        positionId: positionid,
        positionType: positiontype,
      };

      await Appointment.directAppointmentDeleteApplications(payload, body);
      toast.show("Delete Successfully", AlertStatus.SUCCESS);
      toggleDeleteAlert();
      setTimeout(() => {
        fetchData(payload);
        toggleDeleteAlert();
      }, 2000);
      setIsLoading(false);
      setSelectedGroup({
        groupId: null,
        members: [],
        positionId: null,
        membersDetails: [],
        positionType: "",
      });
    } catch (err) {
      setIsLoading(false);
      Sentry.captureException(err);
    }
  };

  const getRows = (searchResults) => {
    let previousDivisionName = null;

    return searchResults
      .map((group, index) => {
        if (isEmptyObj(group)) {
          return null;
        }
        const isGroupSelected = selectedGroup.groupId === group.id;
        const isAnyMemberSelected = selectedGroup.members.length > 0;

        const showDivisionName =
          group.subDivisionName.toLowerCase() === "student"
            ? group.divisionName !== previousDivisionName
            : group.subDivisionName !== previousDivisionName;

        previousDivisionName =
          group.subDivisionName.toLowerCase() === "student"
            ? group.divisionName
            : group.subDivisionName;
        return (
          <>
            {showDivisionName && (
              <TableRow key={`${previousDivisionName}-division`}>
                <TableCell
                  colSpan={4}
                  style={{
                    background: "#cfe3ff",
                  }}
                >
                  {previousDivisionName.split(" (")[0]}
                </TableCell>
              </TableRow>
            )}
            <TableRow
              style={
                selectedRow === index ? { backgroundColor: "#cfe3ff" } : null
              }
              key={index}
            >
              <TableCell style={{ ...Styles.cell, paddingRight: "100px" }} />
              <TableCell style={Styles.cell}>
                {group.positionName || "NA"}
              </TableCell>
              <TableCell style={Styles.cell}>
                {group.members.length === 0 ? (
                  <div>No {group.positionName}</div>
                ) : (
                  group.members.map((member, memberIndex) => {
                    const { groupId, members } = selectedGroup;
                    const checked =
                      group.id === groupId &&
                      members.includes(member?.memberId);

                    return (
                      <Box key={memberIndex}>
                        <div>
                          <label>
                            {member ? (
                              <>
                                <Tooltip
                                  title="If you want to replace or remove this member, select the checkbox"
                                  placement="top"
                                >
                                  <span
                                    style={{
                                      marginRight: "10px",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={checked}
                                      onChange={(e) =>
                                        toggleMemberSelection(
                                          member?.memberId,
                                          group.positionId,
                                          group.id,
                                          e.target.checked,
                                          member
                                        )
                                      }
                                    />
                                  </span>
                                </Tooltip>
                                {member.fullName} ({member.memberId}) (
                                {getDirectAppointmentType(group.positionType)})
                              </>
                            ) : (
                              `No ${group.positionName}`
                            )}
                          </label>
                        </div>
                      </Box>
                    );
                  })
                )}
              </TableCell>
              <TableCell style={Styles.cell}>
                <Box style={{ ...Styles.ActionBtnContainer }}>
                  <Button
                    variant="outlined"
                    style={{
                      ...Styles.applyButton,
                      marginBottom: "10px",
                    }}
                    onClick={() => handleAppointNew(group.id)}
                    label="APPOINT NEW"
                  />
                  {isGroupSelected &&
                    isAnyMemberSelected &&
                    selectedGroup.members.length === 1 && (
                      <Button
                        variant="outlined"
                        style={{
                          ...Styles.applyButton,
                          marginBottom: "10px",
                          lineHeight: "17px",
                        }}
                        onClick={acceptAppointmentHandler}
                        label="No Longer Hold Position"
                      />
                    )}
                  {isGroupSelected &&
                    isAnyMemberSelected &&
                    selectedGroup.members.length === 1 && (
                      <Button
                        variant="outlined"
                        style={{
                          ...Styles.applyButton,
                          marginBottom: "10px",
                        }}
                        onClick={deleteAppointmentHandler}
                        label="Delete"
                      />
                    )}
                </Box>
              </TableCell>
            </TableRow>
          </>
        );
      })
      .filter(Boolean);
  };

  const handleSearch = async (values, e) => {
    e.preventDefault();

    if (!values[APPOINTMENT_TYPE_SEARCH.TYPE]) {
      toast.show("Please select special group field", AlertStatus.ERROR);
      return;
    }

    setShowTable(true);

    const selectedOption = GROUP_OPTIONS.find(
      (option) => option.value === values[APPOINTMENT_TYPE_SEARCH?.TYPE]
    );

    let subdivisionIds = "";
    if (selectedOption?.value === "SD") {
      subdivisionIds = `${selectedOption?.subdivisionIds?.split(",")[0]},${
        selectedOption?.subdivisionIds?.split(",")[1]
      }`;
    } else if (selectedOption?.value === "FD") {
      subdivisionIds = selectedOption?.subdivisionIds;
    }

    const params = {
      divisionId: selectedOption?.divisionIds,
      subdivisionId: subdivisionIds,
    };

    fetchData(params);
  };

  useEffect(() => {
    if (!modalOpen) {
      fetchData(payload);
    }
  }, [appointedMembers, payload, modalOpen]);

  return (
    <Box>
      <Box style={Styles.filters}>
        <Formik
          initialValues={{
            [APPOINTMENT_TYPE_SEARCH?.TYPE]: "",
          }}
        >
          {({ values, errors, handleChange, setFieldValue, handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <Box style={{ display: "block" }}>
                <Box style={{ marginBottom: "2rem" }}>
                  {" "}
                  {/* Dropdown wrapper */}
                  <Box width="30%">
                    <Dropdown
                      name={APPOINTMENT_TYPE_SEARCH?.TYPE}
                      value={values[APPOINTMENT_TYPE_SEARCH?.TYPE]}
                      options={GROUP_OPTIONS}
                      label="Select Special Group"
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      errors={errors}
                      showCross
                      handleClearValue={() =>
                        setFieldValue(APPOINTMENT_TYPE_SEARCH?.TYPE, "")
                      }
                      required
                    />
                  </Box>{" "}
                </Box>
                <div
                  style={{
                    display: "flex",
                    justifyContent: isMobile ? "center" : "flex-start",
                    paddingTop: isMobile ? "20px" : "10px",
                    marginRight: isMobile ? "15px" : "10px",
                    paddingBottom: isMobile ? "100px" : "0px",
                  }}
                >
                  <MuiButton
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{
                      width: isMobile ? "90%" : "auto",
                    }}
                    onClick={(e) => handleSearch(values, e)}
                  >
                    Search
                  </MuiButton>
                </div>{" "}
              </Box>
            </form>
          )}
        </Formik>
      </Box>
      {showTable && (
        <>
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography component="p" color="#8C8C8C" weight={500} my={4}>
              Members Appointed For &quot;National - BSG&quot;
            </Typography>
            <Typography
              component="div"
              color="red"
              weight={500}
              my={4}
              style={{
                fontSize: "16px",
                paddingRight: "30px",
              }}
            >
              <span style={{ display: "block" }}>
                *If you want to replace or remove the member, select the
              </span>
              <span style={{ display: "block" }}>
                checkbox or else you can appoint a new member to that position
              </span>
            </Typography>
          </Box>

          {searchData.length === 0 ? (
            <Box style={Styles.emptyContainer}>
              <h1 style={Styles.noDataMsg}>No Results</h1>
            </Box>
          ) : (
            <CustomTable
              columnCellStyle={{ textAlign: "center" }}
              scrollable
              columns={DIRECT_APPOINTMENT_COL}
              rows={getRows(searchData)}
              tableBodyTheme="#F6F6F6"
              tableHeadCellStyle={{
                ...Styles.tableHeadCells,
              }}
            />
          )}
        </>
      )}
      {isLoading && <Loader />}
      <SearchResultNationalSpecial
        open={modalOpen}
        onClose={closeModal}
        appointedMembers={appointedMembers}
        payload={payload}
      />
      <Alert open={openAlert} onClose={toggleAlert} onSubmit={handleRemove} />
      <Alert
        open={openDeleteAlert}
        onClose={toggleDeleteAlert}
        onSubmit={handleDelete}
      />
    </Box>
  );
}

export default NationalSpecialGroup;
